// Presentation only: leave API values intact for sorting, editing and submission.
export function formatDateTime(value) {
  if (value === null || value === undefined || value === '') return '-'
  let date
  if (value instanceof Date) {
    date = value
  } else if (typeof value === 'number' || /^-?\d{10,13}$/.test(String(value).trim())) {
    const timestamp = Number(value)
    date = new Date(Math.abs(timestamp) < 1e11 ? timestamp * 1000 : timestamp)
  } else {
    const text = String(value).trim()
    // SQL/local dates must not shift a day because date-only ISO is parsed as UTC.
    const local = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?)?$/.exec(text)
    if (local) {
      const [, year, month, day, hour = '00', minute = '00', second = '00'] = local
      date = new Date(+year, +month - 1, +day, +hour, +minute, +second)
      if (date.getFullYear() !== +year || date.getMonth() !== +month - 1 || date.getDate() !== +day ||
          date.getHours() !== +hour || date.getMinutes() !== +minute || date.getSeconds() !== +second) return '-'
    } else {
      // Offset-bearing ISO strings are converted to the browser's local time.
      date = /^\d{4}-\d{2}-\d{2}T/.test(text) ? new Date(text) : new Date(NaN)
    }
  }
  if (Number.isNaN(date.getTime())) return '-'
  const pad = number => String(number).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

export function formatTableDateTime(row, column, value) {
  return formatDateTime(value)
}
